import referralsActions from './actions';

const initialState = {
    collection: {},
    searchReferralText: '',
    referralsError: '',
    referralsSuccess: '',
    isLoadingReferrals: false,
};

export default function projectsReducer(state = initialState, action) {
    switch (action.type) {
        case referralsActions.LOAD_NOT_OWNED_REFERRALS_START:
            return { ...state, ...action.payload, isLoadingReferrals: true };
        case referralsActions.LOAD_NOT_OWNED_REFERRALS_SUCCESS:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.LOAD_NOT_OWNED_REFERRALS_FAILED:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.LOAD_OWNED_REFERRALS_START:
            return { ...state, ...action.payload, isLoadingReferrals: true };
        case referralsActions.LOAD_OWNED_REFERRALS_SUCCESS:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.LOAD_OWNED_REFERRALS_FAILED:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.CREATE_REFERRAL_START:
            return {
                ...state,
                ...action.payload,
                isLoadingReferrals: true,
            };
        case referralsActions.CREATE_REFERRAL_SUCCESS:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.CREATE_REFERRAL_FAILED:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.EDIT_REFERRAL_START:
            return { ...state, ...action.payload, isLoadingReferrals: true };
        case referralsActions.EDIT_REFERRAL_SUCCESS:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.EDIT_REFERRAL_FAILED:
            return { ...state, ...action.payload, isLoadingReferrals: false };
        case referralsActions.DELETE_REFERRAL_START:
            return { ...state, ...action.payload };
        case referralsActions.DELETE_REFERRAL_SUCCESS:
            return { ...state, ...action.payload };
        case referralsActions.DELETE_REFERRAL_FAILED:
            return { ...state, ...action.payload };
        case referralsActions.SET_SEARCH_REFERRAL_TEXT:
            return { ...state, searchReferralText: action.payload };
        default:
            return state;
    }
}